module.exports = __webpack_public_path__ + "static/media/checkoutrecipepagebackground.8fae47db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/checkoutrecipepagebackground.jpg
// module id = 325
// module chunks = 0